const cachedShaders = new Map<string, string>();
class TransitionService {
  static async getTransitionShader(shaderUrl: string) {
    if (cachedShaders.has(shaderUrl)) {
      return cachedShaders.get(shaderUrl)!;
    }
    const shaderSrc = await fetch(shaderUrl).then((data) => data.text());
    cachedShaders.set(shaderUrl, shaderSrc);
    return shaderSrc;
  }
}

export { TransitionService };
